import { useMemo, useState } from 'react';
export function useIsFocusedOrKeyboardFocused(forceFocused, forceKeyboardFocused) {
  var [pressed, setPressed] = useState(false);
  var [focused, setFocused] = useState(false);
  var [keyboardFocused, setKeyboardFocused] = useState(false);
  var eventHandlers = useMemo(() => ({
    onMouseDown(event) {
      // only set the states if the left mouse button was pressed
      if (!event.button || event.button === 0) {
        setPressed(true);
        setKeyboardFocused(false);
      }
    },
    onMouseUp() {
      setPressed(false);
    },
    onMouseOut() {
      setPressed(false);
    },
    onTouchStart() {
      setKeyboardFocused(false);
      setPressed(true);
    },
    onTouchEnd() {
      setPressed(false);
    },
    onFocus() {
      setFocused(true);
      if (!pressed) {
        setKeyboardFocused(true);
      }
    },
    onBlur() {
      setPressed(false);
      setFocused(false);
      setKeyboardFocused(false);
    }
  }), [pressed]);
  var stateAccessors = useMemo(() => ({
    activateMouseFocus: () => {
      setFocused(true);
      setKeyboardFocused(false);
    }
  }), []);
  return [forceFocused !== undefined ? forceFocused : focused, forceKeyboardFocused !== undefined ? forceKeyboardFocused : keyboardFocused, eventHandlers, stateAccessors];
}
//# sourceMappingURL=index.js.map